export default __webpack_public_path__ + "static/media/happy.3a7e5e2d.png";